export default __webpack_public_path__ + "static/media/LoyaltyActive.4086a2aa.svg";